export const generateUniqueId: any = () => {
  const time = Date.now();
  const last = generateUniqueId.last || time;
  generateUniqueId.last = time > last ? time : last + 1;
  return (generateUniqueId.last + Math.random()).toString(32);
};
